
import commonApi from "@/apis/common.api";
import { $_DKD, $_WC } from "@/confs/common.const.js";
import gripUtil from "@/libs/grip.util";

export default {
    state: {
        readList: [],
        read: {},
        readDetail: [],
    },
    getters: {
        getReadList(state) {
            return state.readList;
        },
        getRead(state) {
            return state.read;
        },
        getReadDetail(state) {
            return state.readDetail;
        },
    },
    mutations: {
        READ_LIST(state, readList) {
            state.readList = readList;
        },
        READ(state, read) {
            state.read = read;
        },
        READ_DETAIL(state, readDetail) {
            state.readDetail = readDetail;
        },
    },
    actions : {
        FETCH_READ_LIST({commit}) {
            let q = 'where=val3::Y&orderBy=val1::asc';
            return commonApi.fetchRepoDataList($_DKD.READ, q, true)
                .then(res=>{
                    commit('READ_LIST', res.data.data);
                });
        },
        FETCH_READ({commit}, q) {
            return commonApi.fetchRepoDataList($_DKD.READ, q, true)
                .then(res=>{
                    commit('READ', res.data.data[0]);
                });
        },
        // 데이터로 분석한 구정 - 상세
        FETCH_READ_DETAIL({commit}) {
            return commonApi.fetchRepoDataList($_DKD.READ_DETAIL, '', true)
                .then(res => {
                    // let list = res.data.data.sort((p,c) => {
                    //     return Number(p.val3) > Number(c.val3) ? 1 : Number(p.val3) < Number(c.val3) ? -1 : 0;
                    // });
                    let list = res.data.data;
                    list.forEach(d => {
                        d.val12 = [];
                        if(d.val4 === 'link') {
                            // 링크인 경우 ']' 파싱
                            let tmpList = d.val11.split(",");
                            tmpList.forEach(el => {
                                let map = {name: el.split("]")[0], source:el.split("]")[1]}
                                // 데이터 강남 플랫폼 Y인 경우 경로 추가
                                if(d.val6 === 'Y') {
                                    // http 예외처리
                                    if(!map.source.includes('http')) {
                                        map.source = $_WC.cp + map.source;
                                    }
                                }
                                d.val12.push(map);
                            });
                        }
                    });
                    let map = gripUtil.toMap(list, 'val1');
                    for(let key in map) {
                        map[key].sort((p, c) => {
                            return Number(p.val3) > Number(c.val3) ? 1 : Number(p.val3) < Number(c.val3) ? -1 : 0;
                        });
                    }
                    // console.log('map', map);
                    commit('READ_DETAIL', map);
                });
        },

    }
};
